import { render, staticRenderFns } from "./connectMenuRoleDialog.vue?vue&type=template&id=0e268b08&"
import script from "./connectMenuRoleDialog.vue?vue&type=script&lang=js&"
export * from "./connectMenuRoleDialog.vue?vue&type=script&lang=js&"
import style0 from "./connectMenuRoleDialog.vue?vue&type=style&index=0&id=0e268b08&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports